// extracted by mini-css-extract-plugin
export default {"error":"FormFieldError-module__error__otrHR","icon":"FormFieldError-module__icon__6HPX1","text":"FormFieldError-module__text__cwg3W"};